export const OrderType = [
  { id: 1, value: "Internal", label: "Internal" },
  { id: 2, value: "Customer", label: "Customer" },
];

export const ORDER_LABEL = "Order";
export const RETURN_ORDER_LABEL = "Return Order";
export const ADD_ORDER_LABEL = "Add Order";
export const VIEW_ORDER_LABEL = "View Order";
export const PRODUCT_CODE_KEY = "Product.product_code";
export const ORDER_STATUS_LABEL = "Order Status";
export const ORDER_STATUS_KEY = "order_status";
export const RATE_KEY = "rate";
export const TAX_LABEL = "Tax";
export const TAX_KEY = "tax";
export const ADD_PAYMENT_ORDER_LABEL = "Add Payment";
export const ORDER_ID = "Order Id";
export const ORDER_TYPE = "Order Type";
export const PAYABLE_AMOUNT = "Payable Amount";
export const PAYABLE_AMOUNT_KEY = "payable_amount";
export const RECEIVED_AMOUNT = "Received Amount";
export const RECEIVED_AMOUNT_ERROR =
  "Received amount must be less than or equal to the current payable amount";
export const RECEIVED_DATE = "received_date";
export const PAYMENT_MODE_KEY = "payment_mode";
export const RECEIVED_AMOUNT_KEY = "received_amount";
export const OUTSTANDING_AMOUNT = "Outstanding Amount";
export const OUTSTANDING_AMOUNT_KEY = "out_standing_amount";
export const PAYMENT_MODE = "Payment Mode";
export const PAYMENT_DATE = "Payment Date";
export const TOTAL_AMOUNT_LABEL = "Total Amount:";
export const CURRENT_PAYABLE_AMOUNT_LABEL = "Current Payable Amount:";
export const CURRENT_OUTSTANDING_AMOUNT_LABEL = "Current Outstanding Amount:";
export const REMARKS_LABEL = "Remarks";
export const REMARKS_KEY = "remarks";
export const PAY_LABEL = "Pay";
export const REFUND_LABEL = "Refund";
export const FINAL_AMOUNT_LABEL = "final_amount";
export const PAID_LABEL = "Paid";
export const RETURN_DATE = "Return Date";
export const REFUNDED_LABEL = "Returned";
export const PARTIALLY_PAID_LABEL = "Partially Paid";
export const PARTIALLY_REFUNDED_LABEL = "Partially Returned";
export const ORDER_TYPE_KEY = "order_type";
export const AUTH_USER_NAME_KEY = "authUser.name";
export const PROJECT_NAME_KEY = "project.project_name";
export const PROJECT_CODE_KEY = "project_code";
export const PROJECT_AMOUNT_KEY = "project.amount";
export const PAYMENT_STATUS_KEY = "payment_status";
export const TOTAL_AMOUNT_KEY = "total_amount";
export const SHIPMENT_DATE_LABEL = "Shipment Date";
export const ORDER_TOTAL_LABEL = "Order Total";
export const PAYMENT_DETAILS_LABEL = "Payment Details";
export const REASON_LABEL = "Reason";
export const RETURN_LABEL = "Return";
export const RETURN_QUANTITY = "Return Quantity";
export const RETURN_QUANTITY_ERROR =
  "Return quantity must be less than or equal to the original quantity";
export const REFUND_DETAILS_LABEL = "Return Details";
export const RETURNED_DETAILS_LABEL = "Returned Details";
export const EXPECTED_SHIPMENT_DATE = "Expected Shipment Date";
export const EXPECTED_SHIPMENT_DATE_ERROR =
  "Expected shipment date must be after or the same as the order date";
export const ORDER_ITEM_KEY = "orderItem";
export const TOTAL_PRICE_KEY = "total_price";
export const AUTH_DRAFT_ID_KEY = "auth_draft_id";
export const MODE_OF_TRANSPORTATION = "Mode Of Transportation";
export const LR_DATE = "LR Date";
export const LR_COPY = "LR copy";
export const LR_NO = "LR No.";
export const VEHICLE_NO = "Vehicle No.";
export const DESTINATION = "Destination";
export const ORIGIN = "Origin";
export const MODE_OF_TRANSACTION_KEY = "mode_of_transaction";
export const ORIGIN_KEY = "origin";
export const DESTINATION_KEY = "destination";
export const VEHICLE_NO_KEY = "vehicle_no";
export const LR_NO_KEY = "lr_no";
export const LR_DATE_KEY = "lr_date";
export const LR_COPY_KEY = "lr_copy";
export const TRANSPORT_DETAILS_LABEL = "Transport Details";
export const AUTH_ID_KEY = "auth_id";

export const ReturnOrderReasons = [
  { id: 1, value: "Changed my mind", label: "Changed my mind" },
  {
    id: 2,
    value: "Ordered the wrong quantity",
    label: "Ordered the wrong quantity",
  },
  { id: 3, value: "Order placed by mistake", label: "Order placed by mistake" },
  { id: 4, value: "Other", label: "Other" },
];

export const ModeOfTransportType = [
  { id: 1, value: "Road", label: "Road" },
  { id: 2, value: "Rail", label: "Rail" },
  { id: 3, value: "Maritime", label: "Maritime" },
  { id: 4, value: "Pipeline ", label: "Pipeline" },
  { id: 5, value: "Air", label: "Air" },
];
